import { t } from '@/i18n';
import { z } from 'zod';
import { MAX_POLL_OPTIONS } from '../../constants';

export const modalFormSchema = z
  .object({
    question: z.string().min(1, t('pages.application_polls.components.polls_edit_modal.schema.required')),
    identifier: z.string().min(1, t('pages.application_polls.components.polls_edit_modal.schema.required')),
    status: z.string().min(1, t('pages.application_polls.components.polls_edit_modal.schema.required')),
    allow_multiple_votes: z.boolean(),
    show_partial_results: z.boolean(),
    disable_comments: z.boolean(),
    enable_home: z.boolean(),
    has_closing_date: z.boolean(),
    closing_date: z.string().optional(),
    team_uuid: z.string().optional(),
    poll_options: z
      .array(
        z.object({
          uuid: z.string().uuid(t('pages.application_polls.components.polls_edit_modal.schema.required_uuid')),
          option_text: z.string().min(1, t('pages.application_polls.components.polls_edit_modal.schema.required')),
          is_editing: z.boolean(),
          image: z.any().refine(image => {
            return !!image;
          }, t('pages.application_polls.components.polls_edit_modal.schema.required_image')),
        }),
      )
      .refine(options => {
        return options?.length >= 2;
      }, t('pages.application_polls.components.polls_edit_modal.schema.required_options'))
      .refine(options => {
        return (options?.length ?? 0) <= MAX_POLL_OPTIONS;
      }, t('pages.application_polls.components.polls_edit_modal.schema.max_options')),
  })
  .refine(
    values => {
      const needDate = values.has_closing_date && !values.closing_date;

      return !needDate;
    },
    {
      message: t('pages.application_polls.components.polls_edit_modal.schema.required'),
      path: ['closing_date'],
    },
  );

export type ModalFormData = z.infer<typeof modalFormSchema>;
